'use client';

import { useEffect, useState } from 'react';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

const EXAMPLE_URL =
  '/baza-lekow/interakcje/klacid-clarithromycinum-125-mg-5-ml-granulat-do-sporzadzania-100033462/zocor-10-simvastatinum-10-mg-tabletki-powlekane-100074640/amlozek-amlodipinum-5-mg-tabletki-100083610/clatra-bilastinum-20-mg-tabletki-100240238/levetiracetam-aurovitas-levetiracetamum-250-mg-tabletki-powlekane-100278560';

export function NotConvincedSection() {
  const pathname = usePathname();
  const [hasAuthSuccess, setHasAuthSuccess] = useState(false);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setHasAuthSuccess(!!document.querySelector('[data-auth-success]'));
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-auth-success'],
    });

    return () => observer.disconnect();
  }, []);

  if (pathname !== '/auth/sign-up' || hasAuthSuccess) {
    return null;
  }

  return (
    <div className="flex w-full max-w-[22rem] flex-col items-center gap-3 pt-5 pb-10">
      <svg
        width="120"
        height="12"
        viewBox="0 0 120 12"
        fill="none"
        className="text-zinc-300 dark:text-zinc-600"
      >
        <path
          d="M2 6c8-8 16 8 24 0s16 8 24 0 16 8 24 0 16 8 24 0 16 8 24 0"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          fill="none"
        />
      </svg>
      <div className="flex w-full flex-col items-center gap-3 rounded-lg bg-[#f7f5ef]/60 px-5 py-5 dark:bg-stone-900/50">
        <p
          className="text-lg text-zinc-400 dark:text-zinc-500"
          style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic' }}
        >
          ...masz wątpliwości?
        </p>
        <Link
          href={EXAMPLE_URL}
          prefetch={false}
          className="group flex w-full items-center justify-center gap-2 rounded-md border-2 border-stone-300 bg-stone-50 px-5 py-2 text-sm font-medium text-stone-600 shadow-[2px_2px_0_0_#d6d3d1] transition-all hover:translate-x-[1px] hover:translate-y-[1px] hover:shadow-[1px_1px_0_0_#d6d3d1] dark:border-stone-500 dark:bg-stone-800 dark:text-stone-200 dark:shadow-[2px_2px_0_0_#78716c] dark:hover:shadow-[1px_1px_0_0_#78716c]"
        >
          Zobacz przykładową analizę 5 leków &rarr;
        </Link>
        <p className="text-[11px] text-zinc-400 dark:text-zinc-500">
          Bez rejestracji &middot; Pełny raport
        </p>
      </div>
    </div>
  );
}
